import React, { useEffect, useRef, useState } from 'react';

/**
 * 🙋 MIJOZ VAZIFASI RUXSATI (Boshqaruvchi F5, 2026-09-27) — vazifa kartasidagi blok.
 * Backend: routes/clients.js (/task-approvals), services/clients.js, docs/knowledge/151.
 *
 * `users.task_needs_approval` bo'lgan odam bergan vazifa `awaiting_owner_approval` da turadi —
 * engine olmaydi. Muallif «kutilmoqda» ni ko'radi; operator yoki loyiha egasi ✅ / ✖ bosadi.
 * Kim bosa olishini server biladi — GET /task-approvals ro'yxatida bo'lsa tugmalar chiqadi
 * (bir nechta karta bitta so'rovni bo'lishadi, 10s kesh). `authFetch` — ref orqali.
 */
let _cache = { at: 0, p: null };
function pendingIds(af, apiUrl) {
  if (_cache.p && Date.now() - _cache.at < 10000) return _cache.p;
  _cache = {
    at: Date.now(),
    p: af(`${apiUrl}/task-approvals`).then(r => (r.ok ? r.json() : [])).then(list => new Set((list || []).map(x => Number(x.taskId)))).catch(() => new Set()),
  };
  return _cache.p;
}

export function OwnerApprovalCard({ authFetch, apiUrl, task, onChanged, dark = false }) {
  const afRef = useRef(authFetch); afRef.current = authFetch;
  const [canDecide, setCanDecide] = useState(false);
  const [busy, setBusy] = useState('');
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    pendingIds(afRef.current, apiUrl).then(ids => { if (alive) setCanDecide(ids.has(Number(task.id))); });
    return () => { alive = false; };
  }, [task.id, apiUrl]);

  const act = async (action) => {
    let note = '';
    if (action === 'reject') {
      const v = window.prompt('Rad etish sababi (muallifga boradi):', '');
      if (v === null) return;
      note = v;
    }
    setBusy(action); setErr('');
    try {
      const r = await afRef.current(`${apiUrl}/task-approvals/${task.id}/${action}`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { setErr(d.error || 'Bajarib bo\'lmadi'); return; }
      _cache = { at: 0, p: null };
      if (onChanged) onChanged();
    } catch (e) { setErr('Ulanib bo\'lmadi'); } finally { setBusy(''); }
  };

  const box = dark
    ? 'mt-3 rounded-lg border border-violet-500/40 bg-violet-500/10 p-3 text-violet-100'
    : 'mt-3 rounded-lg border border-violet-200 dark:border-violet-800 bg-violet-50 dark:bg-violet-900/20 p-3';
  return (
    <div className={box}>
      <div className={`text-xs font-semibold ${dark ? '' : 'text-violet-900 dark:text-violet-200'}`}>🙋 Ruxsat kutilmoqda</div>
      <div className={`text-xs mt-0.5 ${dark ? 'text-violet-200/80' : 'text-violet-800/80 dark:text-violet-300/80'}`}>
        {canDecide
          ? 'Bu vazifani mijoz bergan. Ruxsat bersangiz engine boshlaydi (Claude limiti sarflanadi); rad etsangiz sababi muallifga boradi.'
          : 'Vazifa qabul qilindi. Mas\'ul odam ko\'rib chiqib ruxsat bergach ish boshlanadi — sizga xabar keladi.'}
      </div>
      {canDecide && (
        <div className="flex flex-wrap gap-2 mt-2">
          <button disabled={!!busy} onClick={() => act('approve')}
            className="px-3 py-1.5 text-xs font-semibold bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:opacity-50">{busy === 'approve' ? '⏳' : '✅ Ishga tushirish'}</button>
          <button disabled={!!busy} onClick={() => act('reject')}
            className={`px-3 py-1.5 text-xs rounded-lg border disabled:opacity-50 ${dark ? 'border-violet-400/40 text-violet-100' : 'border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-700'}`}>{busy === 'reject' ? '⏳' : '✖ Rad etish'}</button>
        </div>
      )}
      {err && <div className="text-xs text-red-500 mt-1.5">{err}</div>}
    </div>
  );
}

export default OwnerApprovalCard;
